var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentName,{tag:"component",attrs:{"componentData":_vm.componentData}},[_vm._t("default",function(){return [_c('div',{domProps:{"innerHTML":_vm._s(_vm.app.section.description)}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }